import { OverlayConfig } from '@angular/cdk/overlay';

class RtOverlayConfig extends OverlayConfig {
  public level: number;
  public disablePointerEvents?: boolean;

  constructor(config?: RtOverlayConfig) {
    super(config);
    this.level = config?.level ?? 0;
  }
}

export { RtOverlayConfig as OverlayState, RtOverlayConfig };
